import { render, staticRenderFns } from "./HuaweiService.vue?vue&type=template&id=3663545a&scoped=true&"
import script from "./HuaweiService.vue?vue&type=script&lang=js&"
export * from "./HuaweiService.vue?vue&type=script&lang=js&"
import style0 from "./HuaweiService.vue?vue&type=style&index=0&id=3663545a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3663545a",
  null
  
)

export default component.exports